import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ebb-multi-policy',
    templateUrl: './multi-policy.component.html',
    styleUrls: ['./multi-policy.component.scss'],
    standalone: false
})
export class MultiPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
